import React from 'react';

import { useTranslation } from 'react-i18next';

import { CustomModal, Flex, UiButton } from '@shared/ui';

import { ModalBodyReconciliationOfCalculations } from './ModalBodyReconciliationOfCalculations/ModalBodyReconciliationOfCalculations';
import cls from './ModalReconciliationOfCalculations.module.css';
import { useModalReconciliationOfCalculations } from './useModalReconciliationOfCalculations';
import { Icon } from '../../../../components/newUI/Icon/Icon';
import { Loader } from '../../../../components/UI/NewLoader/Loader/Loader';

interface ModalReconciliationOfCalculationsProps {
    classes?: string;
}

export const ModalReconciliationOfCalculations = ({
    classes,
}: ModalReconciliationOfCalculationsProps) => {
    const { modalMode, onCloseModal, customerModalLoader, onExportAct, can_export_financial_info } =
        useModalReconciliationOfCalculations();

    const { t } = useTranslation();
    return (
        <CustomModal
            classes={classes}
            isOpen={modalMode === 'reconciliation'}
            onHideModal={onCloseModal}
        >
            {customerModalLoader && <Loader variant="light" />}
            <CustomModal.Header>
                <Flex gap={16}>
                    {t('ModalReconciliationOfCalculations.return.modalHeader.title')}
                    {
                        // @ts-ignore
                        can_export_financial_info && (
                            <UiButton
                                startIcon={<Icon iconName="downloadDocument" />}
                                btnText={t(
                                    'ModalReconciliationOfCalculations.return.modalHeader.button.span'
                                )}
                                onClick={onExportAct}
                            />
                        )
                    }
                </Flex>
            </CustomModal.Header>
            <CustomModal.Body classes={cls.ModalReconciliationOfCalculations}>
                <ModalBodyReconciliationOfCalculations />
            </CustomModal.Body>
        </CustomModal>
    );
};
